import { render, staticRenderFns } from "./deleteBoxModal.vue?vue&type=template&id=40175b78&scoped=true&"
import script from "./deleteBoxModal.vue?vue&type=script&lang=js&"
export * from "./deleteBoxModal.vue?vue&type=script&lang=js&"
import style0 from "./deleteBoxModal.vue?vue&type=style&index=0&id=40175b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40175b78",
  null
  
)

export default component.exports